/* global DecompressionStream */
import { QuantumDriveH, 
         QuantumDriveC, 
         GetLabel       }       from "Utilities/utils";
import {useLoader       }       from "components/Covers/loadingCover";
import {useInfoMsgModal }       from "components/Covers/infoMessageModal";

export async function decompressContent(base64String) {
    try {
        // 1. Convert Base64 to a byte arr
        const binaryString = atob(base64String);
        const bytes = Uint8Array.from(binaryString, c => c.charCodeAt(0));

        // 2. DecompressionStream for 'deflate'
        const ds = new DecompressionStream('deflate');
        const writer = ds.writable.getWriter();
        writer.write(bytes);
        writer.close();

        // 3. Read the decompressed stream and convert to text
        const response = new Response(ds.readable);
        const jsonText = await response.text();

        // 4. Parse back into a JSON object
        return JSON.parse(jsonText);

    } catch (err) {
        console.error("Decompression failed:", err);
        return null;
    }
}

export async function Generic_Call(sys_body) 
{
    const   { hideLoader }      = useLoader();  
    const   { showInfoMessage } = useInfoMsgModal();
    let     server_response     = {};
    let     controller          = new AbortController();
    const   timeoutMs           = 29000; // 29 seconds
    let     timeoutId           = setTimeout(() => controller.abort(), timeoutMs);
    let     baseURL             = "";
    if (process.env.REACT_APP_STAGE === "prod") {
        baseURL                 = `https://wzl6hj9sl6.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    else {
        baseURL                 = `https://762z1qbh67.execute-api.us-east-1.amazonaws.com/latest/${sys_body.endpoint}`;
    }
    try {        
        server_response = await fetch(baseURL, {method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                },
                                                body: JSON.stringify(sys_body.content),
                                                signal: controller.signal
                                                });
        clearTimeout(timeoutId);

        if (!server_response.ok) {
            hideLoader();
            throw new Error(`HTTP error! Status: ${server_response.status}`);
        }
        
        const data = await server_response.json();

        return data;
    } 
    catch (error) {
        clearTimeout(timeoutId);
        hideLoader();

        if (error.name === "AbortError") {
            console.error("Request timed out");
            showInfoMessage({header: GetLabel(null, 107), message: "Request timed out error"});
            return { error: "timeout" };
        }

        if (error instanceof TypeError) {
            console.error("Request timed out");
            showInfoMessage({header: GetLabel(null, 107), message: "Request network error"});
            return { error: "network" };
        }

        console.error("Fetch error:", error);
        showInfoMessage({header: GetLabel(null, 107), message: "Unexpected error occurred."});

        return await server_response;
    }
}

export async function GetSeferData(endpoint, content) 
{
    let payload          = {};
    try {    
        let currH            = localStorage.getItem("holocron");
        let currC            = localStorage.getItem("charlore");
        let default_payload = {
            "endpoint": endpoint,
            "content": {
                "holocron": currH,
                "args": content
            }
        };
        // ->> Do something
        payload      = await Generic_Call(default_payload);

        if (payload && payload.response) {
            if (payload?.status?.statusCode == 1939) {
                localStorage.clear();
                window.location.href = '/login';
            }
            else {
                if (typeof payload.response.content === 'string') {
                    payload.response.content = await decompressContent(payload.response.content);
                }            
                if (currH != payload.response.holocron) {
                    QuantumDriveH(payload.response.holocron);
                }
                if (currC != JSON.stringify(payload.response.charlore)){
                    QuantumDriveC(payload.response.charlore);
                }
                return (payload);
            }
        }
    }
    catch (error) {
        console.error("GetSeferData error:", error);
    }
    return (payload);
}